'use client';

import React from 'react';
import Markdown from 'react-markdown';

import {
    Box,
    BoxContent,
    Icon,
    IconName,
    Popover,
    PopoverDirection,
    Row,
    Rows,
    Spacer,
    SpacerSize,
    Sticker,
    Text,
    TextMarkup,
    TypographyBold,
    VariantState,
} from '@bytel/trilogy-react';

import { AnimcoType } from '@app-types/animco';
import { AnimcoTypeEnum } from '@app-types/api/palpatine';

export type AnimcoBoxProps = {
    animco: AnimcoType['box'];
};

export function AnimcoBox({ animco }: AnimcoBoxProps) {
    if (animco.length === 0) return null;

    return (
        <>
            <Box shadowless>
                <BoxContent className='has-text-centered'>
                    <Rows>
                        <Row>
                            <Sticker variant={VariantState.MAIN} label='Bon plan' />
                        </Row>
                        <Row>
                            <Rows>
                                {animco.map((animcoItem) => (
                                    <Row key={animcoItem.text}>
                                        <Markdown
                                            components={{
                                                p: 'span',
                                            }}
                                        >
                                            {animcoItem.text}
                                        </Markdown>
                                        {animcoItem.type === AnimcoTypeEnum.PROMO_CODE && (
                                            <Text
                                                markup={TextMarkup.SPAN}
                                                typo={[TypographyBold.TEXT_WEIGHT_SEMIBOLD, VariantState.MAIN]}
                                            >
                                                {animcoItem.promoCode}
                                            </Text>
                                        )}
                                        {animcoItem.tooltip && (
                                            <Text markup={TextMarkup.SPAN}>
                                                <Popover
                                                    trigger={<Icon name={IconName.INFOS_CIRCLE} />}
                                                    direction={PopoverDirection.LEFT}
                                                >
                                                    {animcoItem.tooltip}
                                                </Popover>
                                            </Text>
                                        )}
                                    </Row>
                                ))}
                            </Rows>
                        </Row>
                    </Rows>
                </BoxContent>
            </Box>
            <Spacer size={SpacerSize.FOUR} />
        </>
    );
}
